import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { IElement, ElementsService, ChatMessage, CurrentService, ProjectService } from 'dbweb-core';
import { NavItem } from './nav-item';

@Injectable()
export class NavtreeService {
	root: NavItem = { children: [] };
	// dataChange = new BehaviorSubject<NavItem[]>([]);
	icons = ['security', 'dns', 'gamepad']; // å¾æ 

	// get data(): NavItem[] {
	// 	console.log(this.dataChange.value);
	// 	return this.dataChange.value;
	// }

	constructor(private eles: ElementsService, private project: ProjectService) {
		// this.initialize();
		this.init();
		for (let i = 0; i < Math.min(this.root.children.length, this.icons.length); i++) {
			this.root.children[i].iconName = this.icons[i];
		}
	}
	init() {
		// è®¾ç½®é¡¹ç®å¾æ 
		if (this.project.categoryIcons && this.project.categoryIcons.length > 0) {
			this.icons = this.project.categoryIcons;
		}
		// å¦æå·²ç»åå§åè¿ï¼åè·³åº
		if (this.root.children.length > 0) {
			return;
		}
		this.eles.getElesAsArray().forEach(element => {
			// åç«¯apiæèå­çº§å·¥ä½åç´ çï¼ä¸éè¦å å¥å°nodeåè¡¨ä¸­
			if (!element.NotMenu) {
				this.addElement(element, this.root, element.Category.split('/'), 0, null, element.Icon);
			}
		});
		// console.log(this.root.children[0].iconName);
		// console.log(this.root);
	}
	private clearText(str: string): string {
		if (str.search(/[0-9]{2}\./) > -1) {
			return str.substr(3);
		}
		return str;
	}
	// éç¨æå¥æåºæ¹æ³éæ¡æå¥
	private addElement(
		ele: IElement,
		parent: NavItem,
		paths: string[],
		level: number,
		parents: NavItem,
		iconName: string
	) {
		if (paths.length === 0) {
			// å®éæå¥çèåé¡¹ï¼ä¹éè¦æåº
			const idx = parent.children.findIndex(
				item => (ele.Label || ele.Name).localeCompare(item.fullTitle || item.name) <= 0
			);
			const node = {
				name: ele.Name,
				fullTitle: ele.Label,
				title: this.clearText(ele.Label || ele.Name),
				url: this.eles.frontElementURL(ele.Name, decodeURI(ele.URL)),
				level: level,
				parent: parents,
				iconName: iconName
			};
			if (idx === -1) {
				parent.children.push(node);
			} else {
				parent.children.splice(idx, 0, node);
			}
			return;
		}
		const findIdx = parent.children.findIndex(item => paths[0].localeCompare(item.name) <= 0);
		let categoryNode: NavItem;
		if (findIdx !== -1 && parent.children[findIdx].name === paths[0]) {
			categoryNode = parent.children[findIdx];
		} else {
			categoryNode = {
				name: paths[0],
				fullTitle: paths[0],
				title: this.clearText(paths[0]),
				level: level,
				parent: parents,
				iconName: iconName,
				children: []
			};
			// å¦ææ¾ä¸å°ï¼åè¯´ææ¯éé¢ä»»ä½ä¸ä¸ªé½å¤§ï¼åæ¯è¿½å å°æåä¸ä¸ª
			if (findIdx === -1) {
				parent.children.push(categoryNode);
			} else {
				parent.children.splice(findIdx, 0, categoryNode);
			}
		}
		this.addElement(ele, categoryNode, paths.slice(1), level + 1, categoryNode, iconName);
	}
}
@Injectable()
export class NavHome {
	portraitURL: string;
	chatMessages: ChatMessage[] = [];
	messageBody: string;
	unread: number = null; // æªè¯»ä¿¡æ¯æ°
	openNodeCurrent: NavItem[] = [];
	activeNode: NavItem[] = [];
	subs: Subscription[] = [];
	constructor(private current: CurrentService, private database: NavtreeService, private prj: ProjectService) {}
	recursionFun(node: NavItem) {
		if (node.level <= 0) {
			return this.openNodeCurrent.push(node);
		}
		if (node.level >= 1) {
			this.openNodeCurrent.push(node);
			this.recursionFun(node.parent);
		}
	}
	recursionFuns(node: NavItem) {
		if (node.level <= 0) {
			return this.activeNode.push(node);
		}
		if (node.level >= 1) {
			this.activeNode.push(node);
			this.recursionFuns(node.parent);
		}
	}
	gradually(node: NavItem) {
		if (this.activeNode.length !== 0) {
			this.activeNode.splice(0, this.activeNode.length);
		}
		this.recursionFuns(node);
	}
	openNode(node: NavItem) {
		const openboolean = this.openNodeCurrent.includes(node);
		if (this.openNodeCurrent.length !== 0) {
			this.openNodeCurrent.splice(0, this.openNodeCurrent.length);
		}
		if (openboolean) {
			if (node.level >= 1) {
				this.recursionFun(node.parent);
			}
			if (node.level === 0) {
				this.recursionFun(this.database.root);
			}
		} else {
			this.recursionFun(node);
		}
	}
	messages() {
		const chatData = JSON.parse(this.prj.loadData('chatdata'));
		if (chatData == null) {
			this.prj.saveData('chatdata', JSON.stringify(this.chatMessages));
		}
		this.subs.push(
			this.current.wsChat.observable.subscribe(
				n => {
					this.chatMessages.push(n);
					this.prj.saveData('chatdata', JSON.stringify(this.chatMessages));
					if (n != null) {
						this.unread = this.unread + 1;
					}
					// console.log(JSON.parse(localStorage.getItem('chatdata')));
				},
				err => console.log(err),
				() => console.log('component')
			)
		);
		this.chatMessages = chatData;
	}
	fromChildFunc(item: NavItem) {
		if (this.activeNode.length !== 0) {
			this.activeNode.splice(0, this.activeNode.length);
		}
		this.recursionFuns(item);
		if (this.openNodeCurrent.length !== 0) {
			this.openNodeCurrent.splice(0, this.openNodeCurrent.length);
		}
		this.recursionFun(item);
	}
}
